export const config = {
  title: "TK Performance & Mechanical | Auto Repair Experts in Conway, SC",
  meta: {
    description:
      "TK Performance & Mechanical offers top-quality auto repair and performance services in Conway, SC. From diagnostics to engine swaps, we keep your vehicle running strong.",
    keywords: [
      "TK Performance",
      "TK Mechanical",
      "auto repair Conway SC",
      "performance upgrades",
      "engine swap",
      "brake service",
      "Conway SC mechanics"
    ],
    author: "TK Performance & Mechanical",
    canonicalUrl: "https://www.tkperformancenautorepair.com/",
  },
  sections: {
    header: {
      businessName: "TK Performance & Mechanical",
    },
    sectionB: {
      heroTitle: "TK Performance & Mechanical",
      heroSubtitle: "Performance-Driven Auto Repairs in Conway, SC",
      learnAboutText: "Book an Appointment",
      phoneNumber: "8436983832",
      phoneLabel: "(843) 698-3832",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1165311626/photo/mechanic-using-a-ratchet-wrench.jpg?s=612x612&w=0&k=20&c=D4XCHr8BeR44hdJXS_Tp-9djQ7jWDKKkBWSKaqhuqK8=",
      cardData: [
        {
          title: "Auto Diagnostics",
          description: "We identify issues fast with state-of-the-art tools.",
        },
        {
          title: "Performance Upgrades",
          description: "Boost horsepower with high-performance parts & tuning.",
        },
        {
          title: "Engine & Transmission",
          description: "Complete rebuilds, swaps, and performance installations.",
        },
      ],
      description:
        "TK Performance & Mechanical specializes in reliable, high-performance auto repair in Conway, SC. Whether it's your daily driver or a track build, we've got you covered.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "From preventative maintenance to full-blown performance builds, our expert mechanics deliver precision and quality every time.",
      cards: [
        {
          title: "Diagnostics",
          description: "Identify problems quickly and accurately.",
          imageSrc: "https://media.istockphoto.com/id/2168533566/photo/car-mechanic-fixing-the-car-in-car-repair-shop-young-engineer-checking-the-car-and-fixing.jpg?s=612x612&w=0&k=20&c=Q-JAfu_gOdxxFDP2b0xFHRI3yakZPhGOvpg5VpuWxoo=",
          imageAlt: "Auto diagnostics",
        },
        {
          title: "Engine Swaps",
          description: "Upgrade or replace engines with confidence.",
          imageSrc: "https://media.istockphoto.com/id/1157179147/photo/checking-oil-in-car-engine.jpg?s=612x612&w=0&k=20&c=UlpxPn7pkghIG3FC7ldhwtFIBwEf6eJOfiUTM_nn8JI=",
          imageAlt: "Engine swap service",
        },
        {
          title: "Brake & Suspension",
          description: "Stay safe and smooth with our brake and suspension work.",
          imageSrc: "https://media.istockphoto.com/id/2190362011/photo/female-mechanic-inspecting-car-brakes-on-hydraulic-lift-in-repair-shop.jpg?s=612x612&w=0&k=20&c=4D78Rc3x43Ym8ToUN_62VRR_mMflwe50wt5nT95hdI0=",
          imageAlt: "Brake repair",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Locally Owned & Operated",
        "ASE Certified Technicians",
        "Honest, Transparent Pricing",
        "Custom Performance Builds",
        "Fast Turnaround Time"
      ],
    },
    sectionD: {
      aboutTitle: "About TK Performance & Mechanical",
      aboutImage: {
        src: "https://media.istockphoto.com/id/612257332/photo/car-repair-garage.jpg?s=612x612&w=0&k=20&c=SHmKngKjlqApPOLo31p0obqq7yQ8-JtHB1jzV0_sVSA=",
        alt: "TK Performance Logo",
      },
      aboutText: [
        "TK Performance & Mechanical is committed to high-quality automotive repair and performance work in Conway, SC.",
        "From general maintenance to complete performance overhauls, our team is here to serve the local community with honesty and skill.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "TK Performance & Mechanical Logo",
      businessName: "TK Performance & Mechanical",
      contact: {
        phone: "8436983832",
        phoneLabel: "(843) 698-3832",
        email: "Koontyler00@icloud.com",
        website: "https://www.tkperformancenautorepair.com/",
        address: "Conway, SC 29526, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Conway, SC 29526, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3310.464637486127!2d-79.0481905!3d33.8360311!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x890071ca2c5ff2fd%3A0x37ecf1f3d729b9fc!2sConway%2C%20SC%2029526!5e0!3m2!1sen!2sus!4v1694662384730!5m2!1sen!2sus",
    },
  },
};

export default config;
